import * as React from 'react'

import { SelectOption } from '../../../store/commonTypes'
import { FieldInputProps, FormikProps, FormikValues } from 'formik'

import cls from './radioGroup.module.sass'
import { useTranslation } from 'react-i18next'

interface Props {
    label: string
    options: SelectOption[]
    field: FieldInputProps<string>
    form: FormikProps<FormikValues>
}

const RadioGroup: React.FunctionComponent<Props> = ({ options, field, form, label }: Props) => {
    const [t] = useTranslation()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        form.setFieldValue(field.name, e.target.value)
    }

    return (
        <div className={cls['radioGroup']}>
            {t(label)}
            <div className={cls['options']}>
                {options.map((option: SelectOption) => {
                    return (
                        <div className={cls['option']} key={option.value}>
                            <input
                                type="radio"
                                name={field.name}
                                id={option.label}
                                value={option.value}
                                onChange={handleChange}
                                checked={option.value === field.value}
                            />
                            <label htmlFor={option.label}>{t(option.label)}</label>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default RadioGroup
